import { render } from "./IconOwnerReport.vue?vue&type=template&id=7d7d5c6c&scoped=true"
const script = {}

import "./IconOwnerReport.vue?vue&type=style&index=0&id=7d7d5c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7d5c6c"]])

export default __exports__